import React, { forwardRef, useEffect, useState } from "react"
import withStyles from "react-jss"
import { pagePadding, bounds } from "../../data/globalStyles"
import IngredientsRows from "./IngredientsRows"
import {
  NAME,
  ABV,
  VOLUME,
  INITIAL_INGREDIENTS,
  INITIAL_MIX_AND_SERVE,
  formatIngredient,
  formatIngredients,
  removeEmptyIngredients,
} from "../../utils/helper"
import {
  INPUT_FADEIN,
  INPUT_FADEOUT,
  ANIMATION_DURATION,
} from "../../data/globalStyles"
import MixAndServeOptions from "./MixAndServeOptions"
import Information from "./Information"
import colors from "../../data/colors"
import { useIsMount } from "../../hooks/useIsMount"

const styles = {
  [`@keyframes ${INPUT_FADEIN}`]: {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
  [`@keyframes ${INPUT_FADEOUT}`]: {
    from: {
      opacity: 1,
    },
    to: {
      opacity: 0,
    },
  },
  container: {
    ...bounds,
    position: "relative",
    background: "#ECE7E1",
    display: "flex",
    flexDirection: "column",
    padding: pagePadding,
    animation: ({ show }) =>
      `${
        show ? `$${INPUT_FADEIN}` : `$${INPUT_FADEOUT}`
      } ${ANIMATION_DURATION}s ease-in-out`,
  },
  addButton: {
    marginTop: "1.5rem",
    border: `2px solid rgba(255, 255, 255, 0.5)`,
    background: colors.white,
    color: "#000000",
    padding: "0.3rem 0.6rem",
    fontFamily: "Futura",
    fontWeight: 500,
    fontSize: "calc(10px + (14 - 10) * ((100vw - 300px) / (1600 - 300)))",
    cursor: "pointer",
  },
}

const InputPage = (
  {
    classes,
    ingredients,
    setIngredients,
    mixAndServe,
    setMixAndServe,
    showObj,
    setShow,
    activeSection,
    onAnimationEnd,
  },
  ref
) => {
  const addEmptyIngredientsRow = () => {
    setIngredients((d) => [...d, INITIAL_INGREDIENTS])
  }
  const isMount = useIsMount()

  const [triggerCheckError, setTriggerCheckError] = useState(false)
  const [submit, setSubmit] = useState(false)

  const [errors, setErrors] = useState({
    ingredientName: [false],
    ingredientVolume: [false],
    ingredientAbv: [false],
    mix: false,
    serve: false,
  })
  const [shake, setShake] = useState(false)

  const checkIngredientErrors = () => {
    let tempErrors = {
      ...errors,
      ingredientName: [false],
      ingredientVolume: [false],
      ingredientAbv: [false],
    }

    ingredients.map((ingredient, i) => {
      if (!ingredient.name && ingredient.name !== 0) {
        tempErrors.ingredientName[i] = true
      }
      if (!ingredient.volume && ingredient.volume !== 0) {
        tempErrors.ingredientVolume[i] = true
      }
      if (!ingredient.abv && ingredient.abv !== 0) {
        tempErrors.ingredientAbv[i] = true
      }
    })

    setErrors(tempErrors)
  }

  const checkErrors = () => {
    let tempErrors = {
      ingredientName: [false],
      ingredientVolume: [false],
      ingredientAbv: [false],
      mix: [false],
      serve: [false],
    }

    ingredients.map((ingredient, i) => {
      if (!ingredient.name && ingredient.name !== 0) {
        tempErrors.ingredientName[i] = true
      }
      if (!ingredient.volume && ingredient.volume !== 0) {
        tempErrors.ingredientVolume[i] = true
      }
      if (!ingredient.abv && ingredient.abv !== 0) {
        tempErrors.ingredientAbv[i] = true
      }
    })

    if (!mixAndServe.mix) {
      tempErrors.mix[0] = true
    }
    if (!mixAndServe.serve) {
      tempErrors.serve[0] = true
    }
    setErrors(tempErrors)
  }

  const updateIngredients = (e, type, index) => {
    const newValue = e.target.value
    const newIngredients = ingredients.map((ingr, i) => {
      if (i === index) {
        if (type === NAME) {
          return {
            ...ingr,
            name: newValue,
          }
        } else if (type === ABV) {
          return {
            ...ingr,
            abv: Number(newValue),
          }
        } else if (type === VOLUME) {
          return {
            ...ingr,
            volume: Number(newValue),
          }
        }
      }
      return ingr
    })
    setIngredients(newIngredients)
    setTriggerCheckError(!triggerCheckError)
  }

  const deleteIngredient = (index) => {
    setIngredients((ing) => ing.filter((_, i) => i !== index))
    console.log(ingredients)
  }

  const populateCocktailIngredientsData = (cocktailData, index) => {
    const formattedIngredients = formatIngredients(cocktailData.ingredients)

    const newIngredientsData = [
      ...ingredients.slice(0, index),
      ...formattedIngredients,
      ...ingredients.slice(index + 1, ingredients.length),
    ]

    setIngredients(newIngredientsData)
    setMixType(cocktailData.mixType)
    setServeType(cocktailData.serveType)
    setTriggerCheckError(!triggerCheckError)
  }

  const setMixType = (val) => {
    setMixAndServe((d) => ({
      ...d,
      mix: val,
    }))
  }

  const setServeType = (val) => {
    setMixAndServe((d) => ({
      ...d,
      serve: val,
    }))
  }

  const populateIngredientData = (ingredient, index) => {
    const formattedIngredient = formatIngredient(ingredient)
    const newIngredientsData = [
      ...ingredients.slice(0, index),
      formattedIngredient,
      ...ingredients.slice(index + 1, ingredients.length),
    ]

    setIngredients(newIngredientsData)
    setTriggerCheckError(!triggerCheckError)
  }

  const goToResults = async () => {
    await checkErrors()
    setSubmit(!submit)
  }

  useEffect(() => {
    if (!isMount) {
      let errorBeforeSubmit = []
      for (var key in errors) {
        if (errors.hasOwnProperty(key)) {
          errorBeforeSubmit.push(errors[key])
        }
      }
      let checkArrayHasTrueVal = (arr) => arr.some((v) => v === true)
      let merged = [].concat.apply([], errorBeforeSubmit)

      if (checkArrayHasTrueVal(merged)) {
        setShake(true)
      } else {
        const i1 = removeEmptyIngredients(ingredients)
        setIngredients(i1)
        setTriggerCheckError(!triggerCheckError)
        setShow({
          inputPage: false,
          result: true,
        })
      }
    }
  }, [submit])

  useEffect(() => {
    showObj.inputPage &&
      ingredients &&
      ingredients.map((ingredient) => {
        ingredient.name && checkIngredientErrors()
      })
  }, [triggerCheckError])

  return activeSection === "inputPage" ? (
    <div
      className={classes.container}
      onAnimationEnd={onAnimationEnd}
      ref={ref}>
      <Information />
      <IngredientsRows
        data={ingredients}
        setData={setIngredients}
        errors={errors}
        setErrors={setErrors}
        updateData={updateIngredients}
        deleteIngredient={deleteIngredient}
        populateCocktailIngredientsData={populateCocktailIngredientsData}
        populateIngredientData={populateIngredientData}
      />
      {ingredients[ingredients.length - 1] &&
      ingredients[ingredients.length - 1].name !== "" &&
      ingredients[ingredients.length - 1].volume !== null &&
      ingredients[ingredients.length - 1].abv !== null ? (
        <div className={classes.addContainer}>
          <button
            className={classes.addButton}
            onClick={addEmptyIngredientsRow}>
            + ADD
          </button>
        </div>
      ) : null}
      <MixAndServeOptions
        errors={errors}
        setErrors={setErrors}
        mixAndServe={mixAndServe}
        setMixType={setMixType}
        setServeType={setServeType}
        goToResults={goToResults}
        setShake={setShake}
        shake={shake}
      />
    </div>
  ) : null
}

export default withStyles(styles)(forwardRef(InputPage))
